import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { environment } from '../../environments/environment';
import { HomeTabDetailsModel } from '../advisor-incentives/advisor-incentives.component';
import { CommonSharedModule } from '../common/shared.module';
import { BatchHistoryComponent } from './batch-history/batch-history.component';
import { BatchManageTemplateComponent } from './batch-manage-template/batch-manage-template.component';
import { BatchUploadTemplateComponent } from './batch-upload-template/batch-upload-template.component';

@Component({
  selector: 'app-batch-email',
  templateUrl: './batch-email.component.html',
  styleUrls: ['./batch-email.component.scss'],
  standalone: true,
  imports: [
    CommonSharedModule,
    BatchUploadTemplateComponent,
    BatchManageTemplateComponent,
    BatchHistoryComponent
  ]
})
export class BatchEmailComponent implements OnInit {
  refreshData = new Subject<boolean>();
  refreshHistoryData = new Subject<boolean>();
  tabList!: HomeTabDetailsModel[];

  get isProdEnvironment(): boolean {
    return environment.isProdEnvironment;
  }

  ngOnInit() {
    this.tabList = [
      new HomeTabDetailsModel(true, true),
      new HomeTabDetailsModel(),
      new HomeTabDetailsModel(),
      new HomeTabDetailsModel(),
      new HomeTabDetailsModel(),
      new HomeTabDetailsModel(),
      new HomeTabDetailsModel(),
      new HomeTabDetailsModel()
    ];
  }

  get isEngagmentCountSelected(): boolean {
    return this.tabList[0].isTabSelected;
  }

  onTabChange(event) {
    this.tabList.forEach(tab => {
      tab.isTabSelected = false;
    });
    this.tabList[event.index].hasTabLoaded = true;
    this.tabList[event.index].isTabSelected = true;
    if (event.index == 1) {
      this.refreshData.next(true);
    }
    if (event.index == 2) {
      this.refreshHistoryData.next(true);
    }
  }
}
